import React from 'react'

const Interest = ({category, detail, logo}) => {

    return (
        <div className="col-sm-6 col-md-3 subpage-block">
            <div className="service-block">
                <div className="service-info">
                    <img src={logo} alt="E-Commerce" />
                    <h4>{category}</h4>
                    <p>
                        {detail}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Interest